import styled, {css} from "styled-components"
import {H4} from "@irati/ui/src/Typography"
import {minWidthMedia} from "@irati/ui/src/global/media"
import multiLineEllipsis from "@irati/ui/src/global/css/multiLineEllipsis"

export default styled(H4)`
  ${({theme}) => css`
    margin-bottom: 10px;
    min-height: 36px;
    overflow-wrap: break-word;
  
    ${multiLineEllipsis(2, 18)};
  
    text-align: left;
    ${minWidthMedia.tablet`
      min-height: 46px;
      margin-bottom: ${theme.spacing.two};
      ${multiLineEllipsis(2, 24)}
    `}
  `}
`
